/**
 * O pedido de abrir o painel do dado (E203.F2, ADR-0146 §1–§3): o clique numa tabela, numa linha ou
 * num texto protegido do documento diz a origem do que está impresso, o próprio texto impresso, a
 * seção e o elemento clicado (o painel abre ao lado dele e devolve o foco a ele ao fechar).
 *
 * A mesa fornece `abrir` pelo contexto; fora da mesa (ou no documento assinado) não há contexto e
 * nada responde.
 */
import { createContext, useContext } from 'react';

import type {
  LinhaDoBlocoData,
  OrigemDoBlocoData,
  ParagrafoDoBlocoData,
} from '@/lib/documentoDaSaida';

export interface PedidoDoDado {
  origem: OrigemDoBlocoData;
  /** O que o documento imprime ali, em texto corrido. */
  impresso: string;
  /** A chave da seção do documento em que o clique aconteceu. */
  secao: string | null;
  elemento: HTMLElement | null;
}

export type AbrirDado = (pedido: PedidoDoDado) => void;

export const AbrirDadoContexto = createContext<AbrirDado | null>(null);

export function useAbrirDado(): AbrirDado | null {
  return useContext(AbrirDadoContexto);
}

export function textoDosParagrafos(paragrafos: readonly ParagrafoDoBlocoData[]): string {
  return paragrafos
    .map((p) => p.trechos.map((t) => t.texto).join(''))
    .filter((texto) => texto.trim() !== '')
    .join(' ');
}

/** A linha da tabela em texto: as células separadas por " · ". */
export function textoDaLinha(linha: LinhaDoBlocoData): string {
  return linha.celulas
    .map((c) => textoDosParagrafos(c.paragrafos))
    .filter((texto) => texto !== '')
    .join(' · ');
}
